// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3BVu6","label":"Labeled_label__1jW3h","divider":"Labeled_divider__1ZdA1"};